import {
  ColumnDefinition,
  OuiRecordDatasource as OuiDatasource,
  OuiDataTableComponent,
  OuiDialogComponent,
  OuiDialogHeaderComponent,
  OuiStackComponent,
} from '@aiz-gl/omni-ui';
import { Component, effect, inject, signal } from '@angular/core';
import { DisplayValueComponent } from '../../components/display-value/display-value.component';
import { PageComponent } from '../../components/page/page';
import { WarehouseManagementSystem } from '../../models/warehouse-management-system.models';
import { WarehouseManagementSystemService } from '../../services/warehouse-management-system/warehouse-management-system.service';
import { BasePageComponent } from '../base/base.component';

@Component({
  selector: 'app-wms',
  standalone: true,
  imports: [
    OuiStackComponent,
    OuiDataTableComponent,
    OuiDialogComponent,
    OuiDialogHeaderComponent,
    DisplayValueComponent,
    PageComponent,
  ],
  templateUrl: './wms.component.html',
})
export class WmsPage extends BasePageComponent {
  private wmsService = inject(WarehouseManagementSystemService);

  wms!: OuiDatasource<WarehouseManagementSystem>;

  erpColumns: ColumnDefinition<WarehouseManagementSystem>[] = [
    {
      columnDef: 'code',
      header: 'Code',
    },
    {
      columnDef: 'name',
      header: 'Name',
    },
  ];

  showDialog = signal<boolean>(false); // This signal is used to show the dialog
  selectedWMS = signal<WarehouseManagementSystem | undefined>(undefined);

  constructor() {
    super();

    effect(() => {
      this.wms = new OuiDatasource(
        this.wmsService.warehouseManagementSystems(),
      );
    });
  }

  handleRowClick(wms: WarehouseManagementSystem) {
    this.selectedWMS.set(wms);
    this.showDialog.set(true);
  }
}
